import { Flex } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import GroupButton, {
  ActionButton,
} from "components/ui/GroupButton/GroupButton";
import { FC, useRef } from "react";
import { useAppModal } from "utils/hooks/ui/useAppModal";
import CreateForm from "../CreateForm/CreateForm";
import { FORM_IDS } from "pages/User/config";
import CustomText from "components/ui/CustomText/CustomText";
import { SearchInput } from "components/ui/SearchInput/SearchInput";
import { getUserListKey } from "utils/hooks/request/useUsers";
import { CommonParamsType } from "constants/types/common";
import { useSWRConfig } from "swr";

type UserActionsProps = {
  handleSearch: (v: string) => void;
  params: CommonParamsType;
};

const UserActions: FC<UserActionsProps> = ({ handleSearch, params }) => {
  const { openCrudModal, closeAll, closeCrudModal } = useAppModal();
  const activeModalId = useRef<string | null>(null);
  const { mutate } = useSWRConfig();

  const handleCloseModal = () => {
    if (activeModalId.current) {
      closeCrudModal(activeModalId.current);
      activeModalId.current = null;
    }
  };

  const handleOpenCreateModal = () => {
    const modalId = openCrudModal(
      <CustomText variant="section-title">Tạo mới người dùng</CustomText>,
      {
        mode: "create",
        formId: FORM_IDS.CREATE,
        children: (
          <CreateForm
            mutate={() => mutate(getUserListKey(params))}
            onClose={() => handleCloseModal()}
          />
        ),
        submitText: "Tạo mới",
      },
      750,
    );
    activeModalId.current = modalId;
  };

  const actions: ActionButton[] = [
    {
      key: "create",
      label: "Tạo mới",
      icon: <IconPlus size={18} />,
      variant: "filled",
      color: "blue",
      isLoading: false,
      onClick: async () => handleOpenCreateModal(),
      permission: "user:create",
    },
  ];

  return (
    <Flex justify={"space-between"} align={"center"}>
      <SearchInput
        value={params.search || ""}
        onChange={handleSearch}
        placeholder="Tìm kiếm thông tin người dùng"
      />
      <GroupButton actions={actions} />
    </Flex>
  );
};

export default UserActions;
